export default "__VITE_ASSET__fYVp7vEl__"